<template>
  <v-ons-page @show="showPage()">

    <v-ons-toolbar class="toolbar--noshadow" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Prix OS - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <app-pull-hook-spinner v-if="isSync"></app-pull-hook-spinner>

    <div class="content content--perfonglet">

      <template v-if="negoceInfos">

        <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item v-if="negoceInfos.date" modifier="nodivider perfdate">
            <div class="center">
              <span>
              Prix {{ negoceInfos.date }}
              </span>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-if="! prix.length" modifier="perfcours nodivider">
            <div class="center">
              <span class="label-grey">
                Aucun prix disponible
              </span>
            </div>
          </v-ons-list-item>

          <v-ons-list-item v-for="(prixItem, prixIndex) in prix" :key="'prix-' + prixIndex" :id="'list-item-prix-' + prixIndex"
                           modifier="perfcours nodivider" expandable :expanded.sync="listExpanded[prixIndex]">

            <div class="center">
              {{ prixItem.label.replace(/([^•]) ([^•])/g, '$1&nbsp;$2') }}
              {{ prixItem.suffix }}
            </div>
            <div v-if="prixItem.cours !== null" class="right">
              <template v-if="prixItem.cours !== ''">
                <div v-if="prixItem.is_flash" class="badge badge-jaune">
                  FLASH
                </div>
                <div v-else-if="prixItem.var !== undefined" class="badge"
                     :class="{ 'badge-vert': (isAppro ? (prixItem.var < 0) : (prixItem.var > 0)), 'badge-rouge': (isAppro ? (prixItem.var > 0) : (prixItem.var < 0)) }">
                  {{ formatCoursDiff(prixItem.var) }}
                </div>
                <div>
                  {{ prixItem.cours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
                </div>
              </template>
              <span v-else class="label-grey">
                {{ negoceInfos.non_dispo ? negoceInfos.non_dispo : 'Non disponible' }}
              </span>
              <span class="list-item__expand-chevron"></span>
            </div>

            <div class="expandable-content">
              <v-ons-list modifier="noborder nopadding">
                <v-ons-list-item v-if="histoList.includes(prixItem.id)" modifier="perfcours chevron" tappable @click="showHisto(prixItem.id)">
                  <div class="center">
                    Voir l'historique
                  </div>
                  <div class="right">
                    <v-ons-icon icon="fa-chart-line"></v-ons-icon>
                  </div>
                </v-ons-list-item>
                <v-ons-list-item v-for="(detailItem, detailIndex) in prixItem.detail" :key="'detail-' + detailIndex" modifier="perfcours">
                  <div class="center">
                    {{ detailItem.title }}
                  </div>
                  <div class="right">
                    <template v-for="(item, index) in detailItem.content">
                      {{ item }}
                      <br :key="'content-' + index">
                    </template>
                  </div>
                </v-ons-list-item>
                <v-ons-list-item v-if="! prixItem.detail" modifier="perfcours nodivider">
                  <div class="center">
                    <span class="label-grey">
                      Aucune information complémentaire
                    </span>
                  </div>
                </v-ons-list-item>
              </v-ons-list>
            </div>

          </v-ons-list-item>

          <v-ons-list-item v-if="isShowConfig" modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="showConfig()">
              Modifier mes prix
            </v-ons-button>
          </v-ons-list-item>

        </v-ons-list>

        <v-ons-list modifier="noborder perflist">

          <v-ons-list-item modifier="perfbutton">
            <v-ons-button v-if="! isAppro" modifier="outline perflarge" @click="showVenteDemande()">
              Vendre à {{ negoceInfos.label }}
            </v-ons-button>
            <app-call-negoce :negoce-infos="negoceInfos" track-infos="onglet" :is-appro="isAppro"></app-call-negoce>
          </v-ons-list-item>

        </v-ons-list>

      </template>

      <template v-else>

        <v-ons-list v-if="user.request && user.request.length" modifier="noborder perflist">
          <v-ons-list-item v-for="item in user.request" :key="item" modifier="perfdetail">
            <div class="left">
              <img class="list-item__thumbnail" :src="require('../assets/imgs/icon_wait_bg@2x.png')">
            </div>
            <div class="center">
              {{ item }}
            </div>
            <div class="right">
              <span class="label-grey">
                En attente
              </span>
            </div>
          </v-ons-list-item>
        </v-ons-list>

        <div v-else class="content--perfalert__empty" style="height: calc(100% - 90px);">
          <section>
            <img src="../assets/imgs/icon_wait_bg@2x.png" />
            <template>
              <h3>Découvrez les prix de vos OS</h3>
              <p>Indiquez les OS à qui vous vendez votre marchandise&nbsp;!</p>
            </template>
          </section>
        </div>

        <v-ons-bottom-toolbar modifier="cta transparent">
          <v-ons-button @click="showNegoceRequest" modifier="large--cta perflarge">
            Ajouter {{ user.request && user.request.length ? 'un autre' : 'mes'}} OS
          </v-ons-button>
        </v-ons-bottom-toolbar>

      </template>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

import AppCallNegoce from '../partials/CallNegoce.vue';
import AppPullHookSpinner from '../partials/PullHookSpinner.vue';

import AppNegoceRequest from './NegoceRequest.vue';
import AppNegoceConfig from './NegoceConfig.vue';
import AppNegoceHisto from './NegoceHisto.vue';
import AppVenteDemande from './VenteDemande.vue';
import AppClientSelect from './ClientSelect.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppCallNegoce, AppPullHookSpinner },
  props: ['pageStack'],
  data() {
    return {
      negoceId: undefined,
      refCulture: '',
      refDestination: '',
      prixId: undefined,
      listExpanded: [],
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    clientInfos() {
      if(this.negoceInfos && this.negoceInfos.is_tech && this.clientConnect.id){
        return this.getClientInfosTech(this.data.negoce.clients, this.clientConnect.id);
      }
    },
    isSync() {
      return this.state.isSync;
    },
    referentiel() {
      return this.data.referentiel;
    },
    histoList() {
      if(this.negoceId
      && this.data.histo.list[this.negoceId]
      && this.data.histo.list[this.negoceId][this.campagne]
      && this.data.histo.list[this.negoceId][this.campagne][this.refCulture]
      && this.data.histo.list[this.negoceId][this.campagne][this.refCulture][this.refDestination]){
        return Object.keys(this.data.histo.list[this.negoceId][this.campagne][this.refCulture][this.refDestination]);
      }
      return [];
    },
    cultLabel(){
      return this.getCultLabel();
    },
    negoceInfos() {
      if(this.negoceId){
        return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
      }
    },
    prix() {
      var list = this.getListPrix(this.negoceInfos, this.refCulture, this.refDestination);
      if(this.clientInfos && this.clientInfos.config){
        list = this.filterListPrix(list, this.clientInfos.config)
      } else if(this.negoceInfos && this.negoceInfos.prix_max && this.negoceInfos.prix_max.config){
        list = this.filterListPrix(list, this.negoceInfos.prix_max.config)
      }
      if(this.negoceInfos && this.negoceInfos.prix_max){
        list = this.maxListPrix(list);
      }
      return list;
    },
    isAppro(){
      return this.refCulture == 'appros';
    },
    isShowConfig() { // isConfig already used
      return ! this.isAppro && this.isConfig(this.negoceInfos.config, this.campagne, this.refCulture, this.refDestination);
    }
  },
  methods: {
    showPage() {
      if(this.prixId){
        for (let i = 0; i < this.prix.length; i++) {
          if(this.prix[i].id == this.prixId){
            this.listExpanded.splice(i, 1, true);
            this.$el.scrollTop = this.$el.querySelector('#list-item-prix-' + i).offsetTop;
            return;
          }
        }
      }
    },
    showVenteDemande() {
      var negoceId = this.negoceId;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      if(this.negoceInfos.is_tech){
        if(this.clientConnect.id){
          negoceId = this.clientConnect.negoceId;
          var clientId = this.clientConnect.id;
          this.pageStack.push({
            extends: AppVenteDemande,
            data() {
              return {
                negoceId: negoceId,
                refCulture: refCulture,
                refDestination: refDestination,
                vente: {
                  client: clientId
                }
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppClientSelect,
            data() {
              return {
                workflow: 'vente',
                refCulture: refCulture,
                refDestination: refDestination
              }
            }
          });
        }
      } else {
        this.pageStack.push({
          extends: AppVenteDemande,
          data() {
            return {
              negoceId: negoceId,
              refCulture: refCulture,
              refDestination: refDestination
            }
          }
        });
        this.sendTrackEvent('negoce click ' + this.negoceId + ' onglet ' + refCulture + ' ' + refDestination);
      }
    },
    showConfig() {
      var negoceId = this.negoceId;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppNegoceConfig,
        data() {
          return {
            negoceId: negoceId,
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    showNegoceRequest() {
      this.pageStack.push(AppNegoceRequest);
    },
    showHisto(prixId) {
      const negoceId = this.negoceId;
      const refCulture = this.refCulture;
      const refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppNegoceHisto,
        data() {
          return {
            negoceId: negoceId,
            refCulture: refCulture,
            refDestination: refDestination,
            prixId: prixId
          }
        },
        onsNavigatorOptions: {
          animation: this.$md ? 'fade' : 'lift' // pour éviter le "swipe to pop" d'iOS
        }
      });
    }
  },
  created() {
    for (let i = 0; i < this.prix.length; i++) {
      this.listExpanded.push(false);
    }
  }
};
</script>

<style>
.list-item--perfdate__center {
  padding-right: 15px;
}
.list-item--perfdate__center span {
  color: var(--perfarmer-gris-normal);
  font-size: 12px;
  margin: 0 auto;
}
.content--perfonglet > img {
  width: 100%;
  margin-top: 0;
}
.content--perfonglet > img + .list {
  margin-top: -4px;
}
img.perfnegoce {
  display: block;
  width: 100%;
  max-height: 110px;
}
</style>